import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { NotificacoesHeader, NotificacoesFilter, NotificacoesTable } from '../../components';
import useNotificacoesListagem from '../hooks/useNotificacoesListagem';

const NotificacoesCard = () => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    handleFilterApply,
    handleLimparFiltros,
    handlePaginationChange,
    handleRowClick,
    columns
  } = useNotificacoesListagem();
  return <Card>
      <CardBody>
        <NotificacoesHeader totalRegistros={totalRegistros} />
        <NotificacoesFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />
        <NotificacoesTable data={data} columns={columns} loading={loading} totalRegistros={totalRegistros} paginationState={paginationState} setPaginationState={handlePaginationChange} onRowClick={handleRowClick} />
      </CardBody>
    </Card>;
};

export default NotificacoesCard;
